import * as React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { ColapsePanel } from '../core/ColapsePanel';
import { HotelBedBookingData } from '../shared/index';
import { isNull } from '../utils/index';
export interface BookingRoomDetailPanelProps extends BaseComponentProps {
    RoomParameter: HotelBedBookingData.BookingRequestRoomParameter;
    bookingDetail: (data: HotelBedBookingData.BookingRequestRoomParameter) => any;
    // rate: HotelBedData.ChackRateHotelRoomRoomRateDetail | undefined;
    roomId: number;
    leadOnly: string;
    // roomData: HotelBedData.ChackRateHotelRoomRoom;
}

export interface BookingRoomDetailPanelState extends BaseComponentState {
    bookingDetail: HotelBedBookingData.BookingRequestRoomParameter;
    component: any;
    title: string;
    versi: number;
}

export class BookingRoomDetailPanel extends BaseComponent<BookingRoomDetailPanelProps, BookingRoomDetailPanelState> {

    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['rate'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = [];

    constructor(props: BookingRoomDetailPanelProps) {
        super(props);
        this.state = {
            bookingDetail: props.RoomParameter,
            component: <span />,
            title: '', versi: 0
        };
    }
    componentDidUpdate(prevProps: BookingRoomDetailPanelProps, prevState: BookingRoomDetailPanelState) {
        if (prevProps.leadOnly !== this.props.leadOnly ) {
            this.dateReturn();
        }
    }

    componentDidMount() {
        this.dateReturn();
    }

    dateReturn() {
        this.setStateHelper(st => {
            if (isNull(this.props.RoomParameter)) {
                st.component = <div />;
                return; // <div />;
            }
            let tabs: any[] = [];
            let tabPanels: any[] = [];
            let j: number = 0;
            if (isNull(st.bookingDetail.paxes)) {
                st.bookingDetail.paxes = [];
            }
            let lopad = 0;
            let lopCh = 0;
            for (let r of this.props.RoomParameter.paxes!) {
                
                if (r.type === "AD") {
                    let pxAdult: HotelBedBookingData.BookingRequestPaxParameter = st.bookingDetail.paxes![j]; 
                    tabs.push(
                        <Tab key={lopad + 'ad'}>Adult {lopad + 1}</Tab>
                    );
                    // let swapIndex: number = j + 0;
                    tabPanels.push(
                        this.renderPaxEntryTabPanel(pxAdult, 'adult_' + j + '.' + lopad, pxAdult.name!, pxAdult.surname!)
                    );
                    lopad++;
                } else {
                    
                    let px: HotelBedBookingData.BookingRequestPaxParameter = st.bookingDetail.paxes![j];
                    tabs.push(
                        <Tab key={lopCh + 'ch'}>children {lopCh + 1}</Tab>
                    );
                    tabPanels.push(

                        this.renderPaxEntryTabPanel(px, j + '.' + lopCh, px.name!, px.surname!)
                    );
                    
                    lopCh++;
                }
                j++;
            }
             
            let component = (
                <Tabs forceRenderTabPanel={true}>
                    <TabList>
                        {tabs}
                    </TabList>
                    {tabPanels}
                </Tabs>
            );
            let title = "People detail for : " + this.props.RoomParameter.roomName + " (" + this.props.RoomParameter!.boardName + ")";
            st.title = title;
            st.component = component;
        });
    }

    renderPaxEntryTabPanel(paxData: HotelBedBookingData.BookingRequestPaxParameter, key: string, valeNeme: string, valesurname: string): JSX.Element {
        return (
            <TabPanel key={key + 'ch'}>
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Name </label>
                        <input
                            key={'txt_name_' + key}
                            type="text"
                            title={'Test edit' + key}
                            className="form-control"
                            defaultValue={valeNeme}
                            placeholder="Name"
                            onBlur={evt => {
                                let val: string = evt.target.value;
                                if (val !== paxData.name) {
                                    console.log('memanggil change : ', val);
                                    this.setStateHelper(
                                        st => {
                                            st.versi += 1;
                                            paxData.name = val;
                                        },
                                        () => {
                                            // console.log('Afther change data: ', this.state.bookingDetail.paxes[0]);
                                            this.props.bookingDetail(this.state.bookingDetail);
                                        });
                                } else {
                                    console.warn('Tidak ada perubahan pada paxname, data: ', paxData);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <label>Surname </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your surname"
                            defaultValue={valesurname}
                            onBlur={evt => {
                                let val: string = evt.target.value;
                                if (val !== paxData.surname) {
                                    this.setStateHelper(
                                        st => {
                                            st.versi += 1;
                                            paxData.surname = val;
                                        },
                                        () => {
                                            this.props.bookingDetail(this.state.bookingDetail);
                                        });
                                }
                            }}
                        />
                    </div>
                </div>
            </TabPanel>);

    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (
            <span>
                <ColapsePanel
                    colapse={true}
                    title={this.state.title}
                    component={this.state.component}
                />
            </span>
        );
    }

}


// WEBPACK FOOTER //
// ./src/new-booking/BookingRoomDetailPanel.tsx